import { API } from 'aws-amplify';
import { decryptCredentials } from './cifrate';
import getBodyAmplify from './configHeaders';
import { withAuditoryAmplify } from '../auditory/provider/hooks';
import { MESSAGE_CANCEL_REQUEST } from './constants/api-constants';

export const postAmplify = async ({
  path,
  data,
  name = 'SALFLEX',
  amplifyType = 'PERSON',
  sendSignal = () => {},
}) => {
  const getHeaders = {
    ...getBodyAmplify(data, amplifyType),
  };

  if (name === 'SALFLEX') {
    getHeaders.headers = { 'x-api-key': decryptCredentials(process.env.REACT_APP_AWS_API_KEY) };
  }

  if (name === 'CANALCROSS') {
    getHeaders.headers = { 'x-api-key': decryptCredentials(process.env.REACT_APP_API_KEY_CROSS_CANAL) };
  }

  const promiseToCancel = API.post(name, path, getHeaders);

  sendSignal(promiseToCancel);

  const response = await promiseToCancel;

  return response;
};

export const getAmplify = async ({
  path,
  payload,
  name = 'SALFLEX',
  sendSignal = () => {},
}) => {
  const promiseToCancel = API.get(name, path, {
    ...getBodyAmplify(payload, 'SALUD-FLEX'),
    headers: { 'x-api-key': decryptCredentials(process.env.REACT_APP_AWS_API_KEY) },
  });

  sendSignal(promiseToCancel);

  const response = await promiseToCancel;
  return response;
};

export const cancelRequest = (promiseToCancel, reason) => {
  API.cancel(promiseToCancel, reason ?? MESSAGE_CANCEL_REQUEST);
};

export const post = withAuditoryAmplify(postAmplify);

export const get = withAuditoryAmplify(getAmplify);

export const cancel = cancelRequest;
